export enum AlertActionTypes {
  GET_ALERTCONDITION_CATS = "GET_ALERTCONDITION_CATS",
  GET_COMPANY_CONDITIONS = "GET_COMPANY_CONDITIONS",
  GET_ALARM_CONDITIONS = "GET_ALARM_CONDITIONS",
  REMOVE_CONDITION = "REMOVE_CONDITION",
  UPDATE_CONDITION = "UPDATE_CONDITION",
}
